import { render, staticRenderFns } from "./WordStructurePreview.vue?vue&type=template&id=436da806&lang=pug&"
import script from "./WordStructurePreview.vue?vue&type=script&lang=js&"
export * from "./WordStructurePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports